'use client';

import type { FC } from 'react';
import type { ConvertedBannerSwiperWidgetData } from '@weberus/shared-types/src/display/widgets/brand-swipe';
import { BubbleBadge } from '@yanolja-rnd/nol-design-system';

import { BaseImage } from '@/app/_components/common/base-image';

interface BrandSwipeItemProps {
  item: ConvertedBannerSwiperWidgetData['items'][0];
  onItemClick: () => void;
}
export const BrandSwipeItem: FC<BrandSwipeItemProps> = ({ item, onItemClick }) => {
  return (
    <a
      href={item.href}
      className="flex w-80 flex-col items-center justify-start gap-6 pt-4 pc:w-100 pc:gap-12 pc:pt-8"
      onClick={onItemClick}>
      <div className="relative flex h-80 w-80 items-center justify-center rounded-16 border-[1px] border-line-neutral-weak2 p-12 pc:h-100 pc:w-100 pc:p-16">
        <span className="relative flex size-56 pc:size-68">
          <BaseImage alt="" className="size-full" src={item.logoUrl} fill />
          {!!item.badge && <Badge title={item.badge} />}
        </span>
      </div>
      <span className="line-clamp-2 text-center text-text-neutral-main typography-body-13-regular-multiline pc:typography-subtitle-18-regular-multiline">
        {item.label}
      </span>
    </a>
  );
};

const Badge: FC<{ title: string }> = ({ title }) => {
  return (
    /**
     * -translate-y-[calc(100%-1px)] 이유
     * 배찌 구현하면서 0.Npx 단위로 미세조정하면서, overflow: hidden; 으로 처리된 상위 요소가 있을경우 경계가 잘려표현
     * @see {@link https://screen.yanolja.in/GsKTfWK5wUZMCT5s}
     * 되는 이슈 존재
     *
     * 상위 요소의 경계선에 맞추기 위해 -1px로 조정
     * */
    <div className="absolute left-1/2 top-0 flex min-w-80 -translate-x-1/2 -translate-y-[calc(100%-1px)] justify-center pc:min-w-100">
      <BubbleBadge>
        <span className="text-text-primary-main typography-label-8-bold pc:typography-body-12-bold">{title}</span>
      </BubbleBadge>
    </div>
  );
};
